import React from "react";
import { Container } from "@mui/material";
import Form from "./components/Form";
import Home from "./Home";
import { FastSpring } from "./components/FastSpring";
import Paddle from "./components/Paddle";
import PaddleInvoice from "./components/PaddleInvoice";
import "bootstrap/dist/css/bootstrap.css";
import { SuccessPage } from "./components/SuccessPage";
import { SuccessInvoicePage } from "./components/SuccessInvoicePage";
import { Routes, Route } from 'react-router-dom';
import TagManager from 'react-gtm-module';

class App extends React.Component {
  render() {

    //Google tag manager
    const tagManagerArgs = {
      gtmId: process.env.REACT_APP_GOOGLE_TAG_MANAGER_ID!,
    };
    TagManager.initialize(tagManagerArgs);

    //Axios configuration is now handled in apiClient.ts
    // Import is not needed here as each component will import apiClient directly
    
    // Check for _ptxn parameter and redirect
    const urlParams = new URLSearchParams(window.location.search);
    const ptxn = urlParams.get('_ptxn');
    if (ptxn && window.location.pathname === '/') {
      window.location.href = `/paddle/invoice/?_ptxn=${ptxn}`;
      return null;
    }
    
    //Route to the right page.
    return (
      <Routes>
        {/*<Route index element={<Container maxWidth="sm"> <Form formType="business" /> </Container>} />*/}
        <Route index element={<Container maxWidth="sm"> <Home/> </Container>} />
        {/*<Route index element={<Container maxWidth="sm"> <FastSpring formType="business" /> </Container>} />*/}
        {/*<Route index element={window.location='https://www.moderncsv.com/buy'} />*/}
        {/*<Route index element={<Container maxWidth="sm"> <Paddle formType={"business"} /> </Container>} />*/}
        <Route path="/paddle/personal" element={<Container maxWidth="sm"> <Paddle formType={"personal"} /> </Container>} />
        <Route path="/paddle/business" element={<Container maxWidth="sm"> <Paddle formType={"business"} /> </Container>} />
        <Route path="/paddle/personal-upgrade" element={<Container maxWidth="sm"> <Paddle formType={"personal-upgrade"} /> </Container>} />
        <Route path="/paddle/business-upgrade" element={<Container maxWidth="sm"> <Paddle formType={"business-upgrade"} /> </Container>} />
        <Route path="/paddle/invoice" element={<Container maxWidth="sm"> <PaddleInvoice /> </Container>} />
        <Route path="/fastspring/personal" element={<Container maxWidth="sm"> <FastSpring formType={"personal"} /> </Container>} />
        <Route path="/fastspring/business" element={<Container maxWidth="sm"> <FastSpring formType={"business"} /> </Container>} />
        <Route path="/personal" element={<Container maxWidth="lg"> <Form formType={"personal"} /> </Container>} />
        <Route path="/business" element={<Container maxWidth="lg"> <Form formType={"business"} /> </Container>} />
        <Route path="/personal-upgrade" element={<Container maxWidth="lg"> <Form formType={"personal-upgrade"} /> </Container>} />
        <Route path="/business-upgrade" element={<Container maxWidth="lg"> <Form formType={"business-upgrade"} /> </Container>} />
        <Route path="/success" element={<Container maxWidth="sm"> <SuccessPage /> </Container>} />
        <Route path="/success-invoice" element={<Container maxWidth="sm"> <SuccessInvoicePage /> </Container>} />
      </Routes>
    );
  }
}


export default App;
